// extracted by mini-css-extract-plugin
module.exports = {"description":"Tabs_description__BCaIk","description__open":"Tabs_description__open__wDLMA","description__close":"Tabs_description__close___QPtq"};